import * as Yup from 'yup'

const valueSchema = Yup.object().shape({
  code: Yup.string(),
  text: Yup.string(),
})

export const preferenceSchema = Yup.object().shape({
  type: Yup.string(),
  category: Yup.string(),
  value: valueSchema,
})

export const arrayPreferenceSchema = Yup.object().shape({
  type: Yup.string(),
  category: Yup.string(),
  value: Yup.array().of(valueSchema),
})

export const validationSchema = Yup.object().shape({
  depth: preferenceSchema.required('Depth is required'),
  undertone: preferenceSchema.required('Undertone is required'),
  skin_type: preferenceSchema.required('Skin type is required'),
  eye_color: preferenceSchema.required('Eye color is required'),
  hair_color: preferenceSchema.required('Hair color is required'),
  hair_type: preferenceSchema.required('Hair type is required'),
  hair_thickness: preferenceSchema.required('Hair thickness is required'),
})
